import NewAttachment from './NewAttachment';
import ExistAttachment from './ExistAttachment';
import Actions from './Actions';

export {
  NewAttachment,
  ExistAttachment,
  Actions,
};



// WEBPACK FOOTER //
// ./src/views/Attachment/components/index.js